import { render, staticRenderFns } from "./SentinelaReport.vue?vue&type=template&id=3e1f0c8c&scoped=true&"
import script from "./SentinelaReport.vue?vue&type=script&lang=ts&"
export * from "./SentinelaReport.vue?vue&type=script&lang=ts&"
import style0 from "./sentinela-report.scss?vue&type=style&index=0&id=3e1f0c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1f0c8c",
  null
  
)

export default component.exports